
import React from 'react';
import { Clock } from "lucide-react";

interface YearCountdownProps {
  timeLeft: number; // in seconds
  totalTime: number; // in seconds
  isSimulating: boolean;
}

const YearCountdown: React.FC<YearCountdownProps> = ({ timeLeft, totalTime, isSimulating }) => {
  if (!isSimulating) return null;
  
  // Format time as MM:SS
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  
  // Calculate percentage for progress bar
  const progressPercent = ((totalTime - timeLeft) / totalTime) * 100;
  
  return (
    <div className="mb-6 animate-fade-in">
      <div className="flex justify-between items-center mb-2">
        <div className="flex items-center text-sm text-muted-foreground">
          <Clock className="mr-2 h-4 w-4 animate-pulse" />
          <span>Year advancing in:</span>
        </div>
        <p className="text-sm font-medium">{formatTime(timeLeft)}</p>
      </div>
      <div className="h-2 w-full bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-bitcoin-primary to-bitcoin-accent rounded-full transition-all duration-300 ease-out"
          style={{ width: `${progressPercent}%` }}
        ></div>
      </div>
    </div>
  );
};

export default YearCountdown;
